"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileIcon = void 0;
var React = require("react");
var classNames = require("classnames");
var __1 = require("../");
// import './style.scss'
var fileTypeMap_1 = require("./fileTypeMap");
var fileIconMap = {
    SPREADSHEET: function (props) { return (React.createElement(__1.IcoFont, __assign({}, props, { className: classNames(props.className, 'sok-file-icon-spreadsheet', 'icofont-file-spreadsheet') }))); },
    TEXT: function (props) { return (React.createElement(__1.IcoFont, __assign({}, props, { className: classNames(props.className, 'sok-file-icon-text', 'icofont-file-text') }))); },
    IMAGE: function (props) { return (React.createElement(__1.IcoFont, __assign({}, props, { className: classNames(props.className, 'sok-file-icon-image', 'icofont-file-jpg') }))); },
    PRESENTATION: function (props) { return (React.createElement(__1.IcoFont, __assign({}, props, { className: classNames(props.className, 'sok-file-icon-presentation', 'icofont-file-powerpoint') }))); },
    PDF: function (props) { return (React.createElement(__1.IcoFont, __assign({}, props, { className: classNames(props.className, 'sok-file-icon-pdf', 'icofont-file-pdf') }))); },
    DWG: function (props) { return (React.createElement(__1.SokIcon, __assign({}, props, { className: classNames(props.className, 'sok-file-icon-dwg', 'sok-icon-dwg') }))); },
    IFC: function (props) { return (React.createElement(__1.SokIcon, __assign({}, props, { className: classNames(props.className, 'sok-file-icon-ifc', 'sok-icon-ifc') }))); },
    FOLDER: function (props) { return (React.createElement(__1.FontAwesome, __assign({}, props, { className: classNames(props.className, 'sok-file-icon-folder', 'fa-folder') }))); },
    OTHER: function (props) { return (React.createElement(__1.FontAwesome, __assign({}, props, { className: classNames(props.className, 'sok-file-icon-other', 'fa-file') }))); },
    ZIP: function (props) { return (React.createElement(__1.FontAwesome, __assign({}, props, { className: classNames(props.className, 'sok-file-icon-zip', 'fa-file-archive') }))); }
};
var fileEndMap = Object.entries(fileTypeMap_1.default).reduce(function (result, _a) {
    var type = _a[0], formats = _a[1];
    return formats.reduce(function (result, format) {
        result[format] = type;
        return result;
    }, result);
}, {});
var regExp = /file-(icon|type)-(.*)/i;
var FileIcon = function (props) {
    var result = regExp.exec(props.className);
    if (result.length > 2) {
        if (result[1] === 'type') {
            var type = fileEndMap[result[2]];
            if (fileIconMap[type]) {
                return fileIconMap[type](props);
            }
        }
        else if (fileIconMap[result[2].toUpperCase()]) {
            return fileIconMap[result[2].toUpperCase()](props);
        }
    }
    return fileIconMap['OTHER'](props);
};
exports.FileIcon = FileIcon;
//# sourceMappingURL=index.js.map